export const categoryOptions = [
  "职场与用工乱象",
  "消费与合同纠纷",
  "公共安全与隐患",
  "财务与商业道德",
  "环境与资源问题",
  "公共服务与流程",
  "其他（请在正文说明）",
];

export const evidenceOptions = [
  "有可公开查证的记录或公开信息",
  "有内部文件类型（不会要求你上传原件）",
  "有亲历者或时间线可以复述",
  "目前只有口头了解，需要核实",
];

export const submitNotes = [
  "正文请控制在 500 字以内，把时间、地点、事情经过讲清楚即可。",
  "不要在正文里写下你的姓名、工号、部门组合或联系方式。",
  "不需要上传任何原件，也不要提交带有拍摄信息的原始文件。",
  "如希望收到反馈，只填一个自定义的匿名回执代号即可。",
];

export const submitHighlights = [
  { icon: "ri-user-forbid-line", label: "无需注册", desc: "不创建账号，不保存登录信息" },
  { icon: "ri-id-card-line", label: "不强制实名", desc: "所有身份字段均为选填" },
  { icon: "ri-file-shred-line", label: "最小留存", desc: "超出处理周期后按流程清理" },
];